import { PVSServiceStrategy } from '@/models/PVSStrategy.ts';
import { UpdatableDataCurEvent } from '@/models/data-cur/dc-event-dto.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { getUpdatePartialDtoPVSAppointment } from '@/utils/appointmentUtils.ts';
import { transformPatientFormDataToDataCurPatient } from '@/utils/patientUtils.ts';

export const data_cur_service_strategy: PVSServiceStrategy = {
    createAppointmentUpdateRequest: (appointment, fields) => {
        const api_url = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DATA_CUR.EVENTS}/update`;
        const params: Record<string, string> = {
            instance_id: appointment.data_cur_links?.instance_id ?? '',
            dc_user_id: fields.patient_id ?? appointment.data_cur_links?.patient_id ?? '',
            event_id: appointment.data_cur_links?.event_id ?? '', // this is not currently used
            is_overlapping_allowed: 'true',
        };

        if (appointment.is_eterno_user) {
            params.user_id = appointment.user_id;
        }

        const body: UpdatableDataCurEvent = getUpdatePartialDtoPVSAppointment<UpdatableDataCurEvent>(
            fields,
            appointment
        );

        return { body, api_url, params };
    },

    createAppointmentCancelRequest: (customer_id, instance_id, appointment) => {
        const api_url: string = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DATA_CUR.EVENTS}/cancel`;
        const headers: Record<string, string | undefined> = { customer_id: customer_id };
        const params: Record<string, string | undefined> = {
            instance_id: instance_id,
            user_id: appointment.user_id,
            dc_user_id: appointment.data_cur_links?.patient_id,
            event_id: appointment.data_cur_links?.event_id,
            apt_id: appointment.id,
        };

        return { api_url, headers, params };
    },

    createUserFetchRequest: (user_id, instance_id) => {
        const api_url: string = ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DATA_CUR.USERS;
        const params: Record<string, string | undefined> = {
            instance_id: instance_id,
            user_id: user_id,
        };

        return { api_url, params };
    },

    createUserCreateRequest: (patient_data) => {
        const api_url: string = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DATA_CUR.USERS}/create`;
        const params: Record<string, string | undefined> = {
            instance_id: patient_data.instance_id,
        };

        return { body: transformPatientFormDataToDataCurPatient(patient_data), api_url: api_url, params: params };
    },

    createUserUpdateRequest: (user_id, instance_id, update_data) => {
        const api_url: string = `API_URL`;
        const params: Record<string, string | undefined> = {
            instance_id: instance_id,
            // TODO: use correct id param for data-cur
            dc_user_id: user_id,
        };

        // TODO: change body to data-cur structure
        return { body: update_data, api_url: api_url, params: params };
    },

    createPvsPractitionersFetch: (instance_id) => {
        const api_url: string = ServiceUrl.PRACTITIONER_API_DOMAIN.SECURE_ADMIN.DATA_CUR.USERS;
        const params: Record<string, string> = {
            instance_id: instance_id,
        };

        return { api_url, params };
    },

    createPvsAppointmentTypesFetchRequest: (instance_id) => {
        const api_url: string = ServiceUrl.PRACTITIONER_API_DOMAIN.SECURE_ADMIN.DATA_CUR.EVENT_TYPES;

        const params: Record<string, string> = {
            instance_id: instance_id,
        };

        return { api_url, params };
    },
};
